import { NgModule , APP_INITIALIZER} from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer, BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './/app-routing.module';
import { AppComponent } from './app.component';
import { MODULES } from './global-modules';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { FooterModule } from './pages/footer/footer.module';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/moment';
import { Amplify } from 'aws-amplify';
import { environment } from 'src/environments/environment';
import { NgxExtendedPdfViewerModule, NgxExtendedPdfViewerService } from 'ngx-extended-pdf-viewer';
import { CommonModule } from '@angular/common';
import { ServiceWorkerModule } from '@angular/service-worker';
import { NgxIndexedDBModule } from 'ngx-indexed-db';
import {dbConfig} from './db-config';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { configurePdfViewer } from './pdf-viewer.config';
import { PhotoGalleryModule } from '@twogate/ngx-photo-gallery';

//This is the new code
Amplify.configure({
  Auth: environment.auth,
  API: environment.api,
  Storage: environment.storage
})

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

// remove when approved hard coded 
  // for testing purposes only
  let firebaseConfig = {
    apiKey: "AIzaSyADFYgsD5ctWh81F25ikNLjp8KYmLYaqs0",
    authDomain: "test-6341f.firebaseapp.com",
    projectId: "test-6341f",
    storageBucket: "test-6341f.firebasestorage.app",
    messagingSenderId: "368903616625",
    appId: "1:368903616625:web:a60de68525774850c7c3d0"
  };
// for testing purposes only

import { registerAllModules } from 'handsontable/registry';
import { SignatureModalComponent } from './utils/signature-modal/signature-modal.component';
import { ImageCaptureModalComponent } from './utils/image-capture-modal/image-capture-modal.component';
import { LightboxAdapter, NgxPhotoswipeModule } from '@fnxone/ngx-photoswipe';
import { CustomLightboxAdapter } from './pages/re-acp/acp-detailing-aid/acp-detailing-aid-view/custom-lightbox.adpater'

registerAllModules();

@NgModule({
  declarations: [
    AppComponent,
    SignatureModalComponent,
    ImageCaptureModalComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireMessagingModule,
    CommonModule,
    NgxExtendedPdfViewerModule,
    BrowserModule,
    FooterModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    TranslateModule.forRoot({
        useDefaultLang: true,
        loader: {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpClient]
        }
    }),
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    // RoundProgressModule,
    NgxIndexedDBModule.forRoot(dbConfig),
    ...MODULES,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerWhenStable:30000',
    }),
    PhotoGalleryModule.forRoot({
      defaultOptions: {
        arrowEl: true,
        indexIndicatorSep: '-',
        bgOpacity: 1,
        zoomEl: true,
        shareEl: false,
        fullscreenEl: true,
        pinchToClose: false,
        closeOnScroll: false,
        closeOnVerticalDrag: false,
      }
    })
  ], 
  providers: [
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: unregisterServiceWorker,
    //   multi: true,
    // },
    {
      provide: APP_INITIALIZER,
      useFactory: (pdfViewerService: NgxExtendedPdfViewerService) => () => {
        configurePdfViewer(pdfViewerService);
        return Promise.resolve();
      },
      deps: [NgxExtendedPdfViewerService],
      multi: true
    },
    {
      provide: LightboxAdapter,
      useClass: CustomLightboxAdapter
    },
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule {
  constructor(matIconRegistry: MatIconRegistry, domSanitizer: DomSanitizer){
    matIconRegistry.addSvgIconSet(domSanitizer.bypassSecurityTrustResourceUrl('./assets/mdi.svg'));
  }
}
